import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Alert } from '@mui/material';
import axios from '../api';

function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const res = await axios.post('/api/login', { usuario, senha });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('usuario', res.data.usuario);
      localStorage.setItem('perfil', res.data.perfil);
      onLogin(res.data.usuario, res.data.perfil);
    } catch (err) {
      setErro(err.response?.data?.error || 'Usuário ou senha inválidos');
    }
    setLoading(false);
  };

  return (
    <Box sx={{ mt: 8, display: 'flex', justifyContent: 'center' }}>
      <Paper sx={{ p: 4, minWidth: 320 }}>
        <Typography variant="h5" gutterBottom>Login</Typography>
        <form onSubmit={handleSubmit}>
          <TextField label="Usuário" value={usuario} onChange={e => setUsuario(e.target.value)} fullWidth sx={{ mb: 2 }} />
          <TextField label="Senha" type="password" value={senha} onChange={e => setSenha(e.target.value)} fullWidth sx={{ mb: 2 }} />
          <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>Entrar</Button>
        </form>
        {erro && <Alert severity="error" sx={{ mt: 2 }}>{erro}</Alert>}
      </Paper>
    </Box>
  );
}

export default Login;
